import React, { useState, useEffect, useRef } from "react";
import { useNetworkState } from "shared/utils/useNetworkState";

const BACK_ONLINE_TIMEOUT = 3000;

const CheckConnectivity = () => {
  const isOnline = useNetworkState();
  const [showBackOnline, setShowBackOnline] = useState(false);
  const previouslyOffline = useRef(false);

  useEffect(() => {
    const handleBackOnline = () => {
      setShowBackOnline(true);
      const timer = setTimeout(() => {
          setShowBackOnline(false);
      }, BACK_ONLINE_TIMEOUT);
      return () => {
        clearTimeout(timer);
      };
    };

    const handleOffline = () => {
      previouslyOffline.current = true;
    };

    if (isOnline && previouslyOffline.current) {
      handleBackOnline();
    }

    if (!isOnline) {
      handleOffline();
    }
  }, [isOnline]);

  return (
      <div
          style={{
              position: "fixed",
              bottom: 0,
              left: 0,
              right: 0,
              zIndex: 9999,
              backgroundColor: isOnline ? "green" : "black",
              color: "white",
              textAlign: "center",
          }}
      >
          {!isOnline && "No internet connection detected"}
          {showBackOnline && "Back online"}
      </div>
  );
};

export default CheckConnectivity;
